<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { cn } from '../ui-utils.ts';

const props = defineProps<{
  class?: HTMLAttributes['class'];
}>();
</script>

<template>
  <div
    data-sidebar="group"
    :class="cn('relative mx-2 mb-2 flex w-[94%] min-w-0 flex-col rounded-lg bg-white/5 p-2', props.class)"
  >
    <slot />
  </div>
</template>
